import { Euler, Vector3 } from 'three';

import { AssetsExtraProperties } from '@/shared/api/assets/assets.types.ts';
import { SocketMapDataProps } from '@/shared/store/socket-map-data/socket-map-data.types.ts';
import { AssetCategoryChild } from '@/shared/types/assets/assets.types.ts';
import { Location } from '@/shared/types/global/locations.types.ts';

export type Vector3NumberProps = [number, number, number];

export type OrbitTransform = {
  position: Vector3;
  rotation: Euler;
  scale: number | Vector3;
  target?: Vector3;
};

export enum MapView {
  FULL = 'FULL',
  SIDE = 'SIDE',
  TOP = 'TOP',
}

export type MapViewTransform = {
  position: Vector3;
  rotation: Euler;
  scale: number;
};

export type MapKey = 'mapKey' | 'mapThumbnailKey';

export interface Cluster {
  id: string;
  posX: number;
  posY: number;
  totalNumber: number;
  trackersData: Partial<SocketMapDataProps>[];
  workerPercentage: number;
}

export type MappedLocationsHistoryProps = {
  color: string;
  companyName: string;
  key: string;
  locations: {
    timeOfLocation: { epochTime: number };
    x: number;
    y: number;
    z: number;
  }[];
  name: string;
  tags: string[];
  type: string;
};

export interface SiteMapRemoteConfigProps {
  FULL: {
    position: Vector3;
    rotation: Euler;
    scale: number;
  };
  SIDE: {
    position: Vector3;
    rotation: Euler;
    scale: number;
  };
  TOP: {
    position: Vector3;
    rotation: Euler;
    scale: number;
  };
  ZONE_EDITOR_OFFSETS: number[];
}

type AnchorProps = Partial<SocketMapDataProps> & {
  assetCategory?: AssetCategoryChild;
  device_type?: string;
  extraProperties?: AssetsExtraProperties[];
  isActive?: boolean;
  tracker: boolean;
  visible?: boolean;
};

export type TrackersProps = {
  alertRadius?: number;
  alertZOffset?: number;
  anchor: AnchorProps;
  hasHazardArea?: boolean;
  isActiveBasedOnTimestamp?: boolean;
  location: Location;
  tagName: string;
  tagResName: string;
  visible?: boolean;
};
